@if (backupModel && backupModel.DateCreated) {
    <div class="detail-page-summary">
        <div class="row">
            <div class="col-6">
                <div class="property">
                    <b>{{ "detailMain.summaryId" | t }}</b>
                    {{ backupModel.Identifier }}
                </div>
                <div class="property text-truncate">
                    <b>{{ "detailMain.summaryName" | t }}</b>
                    {{ backupModel.Name }}
                </div>
                <div class="property">
                    <b>{{ "detailMain.summaryRegistrationDate" | t }}</b>
                    {{ backupModel.DateCreated | dateFormat }}
                </div>
            </div>
            <div class="col-6">
                <div class="property">
                    <b>{{ "detailMain.summaryLastModifier" | t }}</b>
                    {{ backupModel.LastModifier }}
                </div>
                <div class="property">
                    <b>{{ "detailMain.summaryControlOwner" | t }}</b>
                    {{ backupModel.Owner }}
                </div>
            </div>
        </div>
    </div>
}

@if (controlFormGroup && standingData) {
    <form [formGroup]="controlFormGroup" data-uiid="control-detail-form">
        <control-detail-overview
            data-uiid="control-detail-testscores"
            [ControlGuid]="controlModel.Guid"
            [Label]="'detailMain.testScores' | t"
            [HideOpenControlButton]="true"
            [HideControlDetails]="true"
            [HideDesignScore]="false"
            [HideEffectivenessScore]="false"
        >
        </control-detail-overview>

        <div class="detail-page-card">
            <div class="detail-page-card-title">{{ 'detailMain.controlDetailTitle' | t }}</div>
            <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
                <div class="row">
                    <div class="col-12 col-xl-6 left-block">
                        <div class="form-group">
                            <label for="controlCatalogueSelect">{{ 'detailMain.controlCatalogueLabel' | t }}</label>
                            <ng-select
                                data-uiid="control-detail-controlcatalogue"
                                id="controlCatalogueSelect"
                                name="controlCatalogueSelect"
                                [items]="standingData.ControlCatalogues"
                                formControlName="ControlCatalogue"
                                bindLabel="Name"
                                bindValue="ID"
                                (change)="onControlCatalogueChange($event)"
                            >
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <cerrix-textfield
                                [fieldLabel]="'detailMain.controlNameLabel' | t"
                                dataUiid="control-detail-controlname"
                                identifier="controlNameInput"
                                formControlName="Name"
                                [placeholder]="'detailMain.controlNamePlaceholder' | t"
                            ></cerrix-textfield>
                        </div>
                        <div class="row">
                            <div class="form-group col">
                                <ai-description-generator
                                    [fieldLabel]="'detailMain.descriptionLabel' | t"
                                    dataUiid="control-detail-description"
                                    identifier="controlDescriptionInput"
                                    [rows]="4"
                                    formControlName="Description"
                                    [fetchDescriptionsDatamethod]="fetchDescriptions"
                                    (onDescriptionGenerated)="onDescriptionGenerated($event)"
                                ></ai-description-generator>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-6 right-block">
                        <div class="form-group">
                            <label>{{ 'detailMain.organizationLabel' | t }}</label>
                            <cerrix-select-tree
                                data-uiid="control-detail-organization"
                                [tree]="standingData.Organizations"
                                formControlName="Organization"
                                placeholder="Required"
                                [multiselect]="false"
                                (onChangeSingleId)="reloadBusinessData()"
                            >
                            </cerrix-select-tree>
                        </div>
                        <div class="form-group">
                            <label
                                >{{ 'detailMain.businessDimensionsLabel' | t }}
                                @if (!selectedOrganizationId) {
                                    <i
                                        class="far fa-question-circle ms-2"
                                        [matTooltip]="'detailMain.pleaseSelectOrgFirst' | t"
                                    ></i>
                                }
                            </label>
                            <cerrix-select-tree
                                data-uiid="control-detail-businessdimensions"
                                [tree]="standingData.BusinessDimensions"
                                formControlName="BusinessDimensions"
                                [multiselect]="true"
                                [readonly]="!selectedOrganizationId"
                                (onChangeIds)="reloadFrameworkDimensions($event)"
                            >
                            </cerrix-select-tree>
                        </div>
                        <div class="form-group">
                            <label
                                >{{ 'detailMain.frameworkDimensionsLabel' | t }}
                                @if (!selectedOrganizationId) {
                                    <i
                                        class="far fa-question-circle ms-2"
                                        [matTooltip]="'detailMain.pleaseSelectOrgFirst' | t"
                                    ></i>
                                }
                            </label>
                            <cerrix-select-tree
                                data-uiid="control-detail-frameworkdimensions"
                                [tree]="standingData.FrameworkDimensions"
                                formControlName="FrameworkDimensions"
                                [multiselect]="true"
                                [readonly]="!selectedOrganizationId"
                            >
                            </cerrix-select-tree>
                        </div>
                        <div class="form-group">
                            <label> {{ 'detailMain.applicableOrganizationsLabel' | t }} </label>
                            <cerrix-select-tree
                                data-uiid="control-detail-applicable-organizations"
                                [tree]="standingData.AllApplicableOrganizations"
                                formControlName="ApplicableOrganizations"
                                [multiselect]="true"
                                [readonly]="true"
                            >
                            </cerrix-select-tree>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-xl-6 left-block">
                        <hr />
                        <div class="row">
                            <div class="form-group-inline col-4">
                                <i class="fas fa-key mx-2"></i>
                                <cerrix-checkbox
                                    data-uiid="control-detail-keycontrol"
                                    formControlName="KeyControl"
                                    [label]="'detailMain.keyControlLabel' | t"
                                    fontsize="0.9em"
                                >
                                </cerrix-checkbox>
                            </div>
                            <div class="form-group-inline col-4">
                                <i class="fas fa-search mx-2"></i>
                                <cerrix-checkbox
                                    data-uiid="control-detail-requiresmonitoring"
                                    formControlName="RequiresMonitoring"
                                    [label]="'detailMain.monitoringLabel' | t"
                                    [tooltip]="'detailMain.requiresMonitoringTooltip' | t"
                                    fontsize="0.9em"
                                >
                                </cerrix-checkbox>
                            </div>
                            <div class="form-group-inline col-4">
                                <i class="fas fa-search mx-2"></i>
                                <cerrix-checkbox
                                    data-uiid="control-detail-requiresexecution"
                                    formControlName="RequiresExecution"
                                    [label]="'detailMain.executionLabel' | t"
                                    [tooltip]="'detailMain.requiresExecutionTooltip' | t"
                                    fontsize="0.9em"
                                >
                                </cerrix-checkbox>
                                <i
                                    class="far fa-info-circle mx-2"
                                    [matTooltip]="'detailMain.useControlExecutionTooltip' | t"
                                >
                                </i>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-6 right-block">
                        <hr />
                        <div class="row">
                            <div class="form-group-inline col-6">
                                <i class="fas fa-share-alt mx-2"> </i>
                                <cerrix-checkbox
                                    data-uiid="control-detail-isshared"
                                    formControlName="IsShared"
                                    [label]="'detailMain.sharedControlLabel' | t"
                                    fontsize="0.9em"
                                >
                                </cerrix-checkbox>
                                <i
                                    class="far fa-info-circle mx-2"
                                    [matTooltip]="'detailMain.sharedControlTooltip' | t"
                                >
                                </i>
                            </div>
                            <div class="form-group-inline col-6">
                                <i class="fas fa-map-pin mx-2"></i>
                                <cerrix-checkbox
                                    data-uiid="control-detail-inplace"
                                    formControlName="InPlace"
                                    [label]="'detailMain.inPlaceLabel' | t"
                                    fontsize="0.9em"
                                    (valueChange)="checkboxChanged($event)"
                                >
                                </cerrix-checkbox>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-xl-6 left-block">
                        <hr style="margin-top: 0.25em" />
                        <div class="form-group">
                            <label for="controlOwnerSelect">{{ 'detailMain.controlOwnerLabel' | t }}</label>
                            <ng-select
                                data-uiid="control-detail-controlowner"
                                id="controlOwnerSelect"
                                name="controlOwnerSelect"
                                [items]="standingData.ControlOwners"
                                [addTag]="true"
                                formControlName="Owner"
                                bindLabel="Name"
                                bindValue="Name"
                                placeholder="{{ inPlaceChecked ? 'Required' : '' }}"
                            >
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <label for="controlTypeSelect">{{ 'detailMain.typeLabel' | t }}</label>
                            <ng-select
                                data-uiid="control-detail-type"
                                id="controlTypeSelect"
                                name="controlTypeSelect"
                                [items]="standingData.Types"
                                formControlName="Type"
                                bindLabel="Name"
                                bindValue="ID"
                            >
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <label for="controlSourceSelect">{{ 'detailMain.sourceLabel' | t }}</label>
                            <ng-select
                                data-uiid="control-detail-source"
                                id="controlSourceSelect"
                                name="controlSourceSelect"
                                [items]="standingData.Sources"
                                formControlName="Source"
                                bindLabel="Name"
                                bindValue="ID"
                            >
                            </ng-select>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-lg-6">
                                <label>{{ 'detailMain.startDateLabel' | t }}</label>
                                <date-input
                                    data-uiid="control-detail-startdate"
                                    formControlName="StartDate"
                                ></date-input>
                            </div>
                            <div class="form-group col-12 col-lg-6">
                                <label>{{ 'detailMain.endDateLabel' | t }}</label>
                                <date-input
                                    data-uiid="control-detail-enddate"
                                    formControlName="EndDate"
                                ></date-input>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-xl-6 right-block">
                        <hr style="margin-top: 0.25em" />
                        <div class="form-group">
                            <label for="controlFrequencySelect">{{ 'detailMain.controlFrequencyLabel' | t }}</label>
                            <ng-select
                                data-uiid="control-detail-controlfrequency"
                                id="controlFrequencySelect"
                                name="controlFrequencySelect"
                                [items]="standingData.Frequencies"
                                formControlName="Frequency"
                                bindLabel="Name"
                                bindValue="ID"
                            >
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <label for="controlAspectIcSelect">{{ 'detailMain.aspectIcLabel' | t }}</label>
                            <ng-select
                                data-uiid="control-detail-aspectic"
                                id="controlAspectIcSelect"
                                name="controlAspectIcSelect"
                                [items]="standingData.AspectICs"
                                formControlName="AspectIc"
                                bindLabel="Name"
                                bindValue="ID"
                            >
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <label for="controlExecutionSelect">{{ 'detailMain.controlExecutionMethodLabel' | t }}</label>
                            <ng-select
                                data-uiid="control-detail-controlexecutionmethod"
                                id="controlExecutionMethodSelect"
                                name="controlExecutionMethodSelect"
                                [items]="standingData.ControlExecutionMethods"
                                formControlName="ControlExecutionMethod"
                                bindLabel="Name"
                                bindValue="ID"
                            >
                            </ng-select>
                        </div>

                        <div class="form-group">
                            <cerrix-textarea
                                [fieldLabel]="'detailMain.controlObjectiveLabel' | t"
                                dataUiid="control-detail-controlobjective"
                                identifier="controlObjectiveInput"
                                [rows]="4"
                                formControlName="ControlObjective"
                            ></cerrix-textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        @if (useControlAnalysis) {
            <div class="detail-page-card">
                <div class="detail-page-card-title">{{ 'detailMain.controlAnalysisTitle' | t }}</div>
                <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
                    <div class="row">
                        <div class="col-12 col-xl-6 left-block">
                            <div class="form-group">
                                <cerrix-textarea
                                    [fieldLabel]="'detailMain.conclusionSummaryLabel' | t"
                                    dataUiid="control-detail-conclusionsummary"
                                    identifier="conclusionSummaryInput"
                                    formControlName="ConclusionSummary"
                                ></cerrix-textarea>
                            </div>
                        </div>
                        <div class="col-12 col-xl-6 right-block">
                            <div class="form-group">
                                <cerrix-textarea
                                    [fieldLabel]="'detailMain.commentsLabel' | t"
                                    dataUiid="control-detail-comments"
                                    identifier="controlCommentsInput"
                                    formControlName="Comments"
                                ></cerrix-textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-xl-6 left-block">
                            <div class="row">
                                <div class="form-group col-12 col-lg-6">
                                    <label for="initialCostsNumber">{{ 'detailMain.initialCostsLabel' | t }}</label>
                                    <input
                                        data-uiid="control-detail-initialcosts"
                                        type="number"
                                        class="form-control form-control-sm"
                                        id="initialCostsNumber"
                                        name="initialCostsNumber"
                                        formControlName="InitialCosts"
                                    />
                                </div>
                                <div class="form-group col-12 col-lg-6">
                                    <label for="annualCostsNumber">{{ 'detailMain.annualCostsLabel' | t }}</label>
                                    <input
                                        data-uiid="control-detail-annualcosts"
                                        type="number"
                                        class="form-control form-control-sm"
                                        id="annualCostsNumber"
                                        name="annualCostsNumber"
                                        formControlName="AnnualCosts"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }

        @if (raciConfig) {
            <generic-list-manager
                data-uiid="control-detail-raci"
                [config]="raciConfig"
            ></generic-list-manager>
        }

        @if (controlCustomFieldsFormGroup) {
            <!-- Custom fields -->
            <div class="detail-page-card">
                <div class="detail-page-card-title">{{ 'detailMain.customFieldsTitle' | t }}</div>
                <div class="detail-page-card-body padded form-group-styling cerrix-control-sm">
                    <cerrix-custom-fields-editor
                        [parentForm]="controlCustomFieldsFormGroup"
                        [customFieldData]="customFieldData"
                        [singleColumn]="false"
                    ></cerrix-custom-fields-editor>
                </div>
            </div>
        }
    </form>
} @else {
    <!-- Global loader for whole Detail tab -->
    <div class="detail-page-card">
        <div class="detail-page-card-title">{{ 'detailMain.controlDetailTitle' | t }}</div>
        <div class="detail-page-card-body padded cerrix-control-sm">
            <div class="fancy-loader submodule"></div>
        </div>
    </div>
}
